import { request } from '../smart_bps/lib/utils'

export function fetchRequestControlMeta(callback) {
  request({
    method: 'get',
    url: '/api/reports/request_control/meta',
    success: (data) => callback(null, data),
    error: (err) => callback(err || new Error('Ошибка загрузки параметров отчёта')),
  })
}

export function fetchRequestControlSummary(filters, callback) {
  request({
    method: 'post',
    url: '/api/reports/request_control/summary',
    data: { filters },
    success: (data) => callback(null, data),
    error: (err) => callback(err || new Error('Ошибка формирования отчёта')),
  })
}

export function fetchRequestControlDetail(filters, rowKey, columnKey, callback) {
  request({
    method: 'post',
    url: '/api/reports/request_control/detail',
    data: { filters, row_key: rowKey, column_key: columnKey },
    success: (data) => callback(null, data),
    error: (err) => callback(err || new Error('Ошибка загрузки детализации')),
  })
}
